
import {
  AgendamentoRPA,
  Usuario,
  ImpersonatePerfilManutencao
} from '../index';


export class Impersonate {
  "Username";
  "Password";
  "Aplicacao";
  "PerfilResponsavel";
  "UsuarioCadastro";
  "DataCadastro";
  "UsuarioAlteracao";
  "DataAlteracao";
  "id";
  AgendamentoRPA;
  UsuarioCadastroRel;
  UsuarioAlteracaoRel;
  PerfisManutencao;
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Impersonate`.
   */
  static getModelName() {
    return "Impersonate";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Impersonate for dynamic purposes.
  **/
  static factory(data) {
    return new Impersonate(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'Impersonate',
      plural: 'Impersonates',
      path: 'Impersonates',
      properties: {
        "Username": {
          name: 'Username',
          type: 'string'
        },
        "Password": {
          name: 'Password',
          type: 'string'
        },
        "Aplicacao": {
          name: 'Aplicacao',
          type: 'string'
        },
        "PerfilResponsavel": {
          name: 'PerfilResponsavel',
          type: 'number'
        },
        "UsuarioCadastro": {
          name: 'UsuarioCadastro',
          type: 'number'
        },
        "DataCadastro": {
          name: 'DataCadastro',
          type: 'Date'
        },
        "UsuarioAlteracao": {
          name: 'UsuarioAlteracao',
          type: 'number'
        },
        "DataAlteracao": {
          name: 'DataAlteracao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        AgendamentoRPA: {
          name: 'AgendamentoRPA',
          type: 'AgendamentoRPA',
          model: 'AgendamentoRPA'
        },
        UsuarioCadastroRel: {
          name: 'UsuarioCadastroRel',
          type: 'Usuario',
          model: 'Usuario'
        },
        UsuarioAlteracaoRel: {
          name: 'UsuarioAlteracaoRel',
          type: 'Usuario',
          model: 'Usuario'
        },
        PerfisManutencao: {
          name: 'PerfisManutencao',
          type: 'ImpersonatePerfilManutencao[]',
          model: 'ImpersonatePerfilManutencao'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/Impersonate.js